<template>
<div>
        <div
      class="imgInfo"
      :class="{ 'show-info': isShowBottomInfo, 'go-bottom': isGobottom }"
      style="font-size: 13px"
    >
      <img src="@/static/imgs/audiohead.png" alt="" class="head-img" />
      <div class="content">
        <img :src="URL + audioInfo.img" alt class="cover-img" />

        <p class="time">
          {{ isEnglish ? introduceMap[0].english : introduceMap[0].chinese }}
          {{ audioInfo.start_time }}-{{ audioInfo.end_time }}
        </p>

        <p class="address">
          {{ isEnglish ? introduceMap[1].english : introduceMap[1].chinese }}
          {{ audioInfo.address }}
        </p>
        <p v-show="clinet!='h5'" class="xiaoniren-link" style="font-size: 10px; color: #afaead">
          {{ isEnglish ? introduceMap[2].english : introduceMap[2].chinese }}
          <a href="tel: 18801294645">18801294645</a>
        </p>
        <p v-show="clinet!='h5'" class="xiaoniren-link" style="font-size: 10px; color: #afaead">
          {{ isEnglish ? introduceMap[3].english : introduceMap[3].chinese
          }}<a href="https://www.xiaoniren.com" style="color: blue"
            >www.xiaoniren.com</a
          >
        </p>
      </div>
    </div>
</div>
</template>
<script>
   import * as constMap from "@/static/const.js";
   import * as config from "@/api/api";
   export default {
       data() {
           return {
               introduceMap: constMap.introduceDialogEngLishMap,
               URL: config.imgHost,
               clinet:config.client
           }
       },
      props: {
       isShowBottomInfo: {
           type: Boolean,
           default: false
       },
       isEnglish: {
           type: Boolean,
           default: false
       },
       isGobottom: {
           type: Boolean,
           default: false
       },
       audioInfo: {
           type: Object,
           default: ()=>{}
       }
     },
   }
</script>
<style lang="scss">
.show-info {
  top: 100px !important;
  transition: top 0.35s ease-in-out !important;
}
.go-bottom {
  top: -500px !important;
  transition: top 0.25s ease-in-out !important;
}
.imgInfo {
  position: absolute;
  top: -500px;
  left: 50%;
  transform: translateX(-50%);
  width: 370px;
  height: 450px;
  display: block;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  z-index: 10000000000000000;
  overflow: hidden;
  .head-img {
    width: 100%;
    height: 104px;
  }
  .content {
    padding: 8px;
    box-sizing: border-box;
    height: 347px;
    width: 94%;
    margin: 0 auto;
    margin-top: -2px;
    background-color: #ffffff;
    overflow-y: auto;
    // flex: 1;
    border-radius: 3px;
    .cover-img {
      width: 100%;
      height: 210px;
    }
    p {
      text-align: center;
      line-height: 22px;
      font-size: 12px;
      overflow: hidden;
      color: rgb(134, 134, 134);
      padding: 0 36px;
      box-sizing: border-box;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/introduction.vue